import { AppConfigInterface } from "./app-config.interface";

export const config: AppConfigInterface = {
    fullDateFormat1: "eeee, d MMM yyyy H:mm",
    fullDateFormat2: "eeee, d'o' MMMM yyyy [at] H:mm",
    durationFormat: "h [hours], m [minutes]",
};
